import style from "../style/layout.module.css";
export default function Progress({ progressRound }) {
  return (
    <div className={style.progress}>
      <h3>현재 진행도</h3>
      <div className={style.bar}>
        <div
          className={style.progress_bar}
          style={{ width: `${progressRound}%` }}
        ></div>
        <span className={style.progress_text}>{progressRound}%</span>
      </div>
    </div>
  );
}
